import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

export const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
`
export const BankWrapper = styled.div`
  width: 450px;
  height: 100vh;
  padding: 30px 30px;
  background-color: white;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.4);

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: -webkit-fill-available;
    padding: 30px 20px;
    border-radius: 0px;
    position: absolute;
    top: 0px;
    right: 0;
  }
`

export const BankModalContainer = styled.div`
  width: 100%;
  position: relative;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    /* width: 100%; */
    height: 70%;
  }
`

export const BankModalBackground = styled.div`
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100vw;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 80vh;
  }
`
